import Guard from '../../../../AppUtils/Framework/Guard'
import type { IObservableFinisher } from '../../../Model/Observables/IObservableFinisher'
import type ObservableResultsPage from '../../../Model/Observables/ObservableResultsPage'

export interface Params {
  raceInformation: ObservableResultsPage
  raceFinishers: ko.ObservableArray<IObservableFinisher>
  showField: boolean
}

export class FinishersListViewModel {
  public raceInformation!: ObservableResultsPage
  public raceFinishers!: ko.ObservableArray<IObservableFinisher>
  public showField!: boolean

  constructor(params: Params) {
    Guard.notNull(params.raceInformation)

    this.raceInformation = params.raceInformation
    this.raceFinishers = params.raceFinishers
    this.showField = params.showField
  }
}
